import { render, staticRenderFns } from "./indexRenovation.vue?vue&type=template&id=7dedadb2&scoped=true"
import script from "./indexRenovation.vue?vue&type=script&lang=js"
export * from "./indexRenovation.vue?vue&type=script&lang=js"
import style0 from "./indexRenovation.vue?vue&type=style&index=0&id=7dedadb2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dedadb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dedadb2')) {
      api.createRecord('7dedadb2', component.options)
    } else {
      api.reload('7dedadb2', component.options)
    }
    module.hot.accept("./indexRenovation.vue?vue&type=template&id=7dedadb2&scoped=true", function () {
      api.rerender('7dedadb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mallManagement/indexRenovation/indexRenovation.vue"
export default component.exports